export var buttonContentStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: v.contentFontSize,
      fontWeight: v.contentFontWeight,
      lineHeight: v.contentLineHeight
    }, p.size === 'small' && {
      fontSize: v.sizeSmallContentFontSize,
      lineHeight: v.sizeSmallContentLineHeight
    });
  }
};
//# sourceMappingURL=buttonContentStyles.js.map
